<div class="container p-4">
    <div>
        <h4 class="d-inline me-5">Create User</h4>
        <div class="form-check d-inline ms-5">
            <input class="form-checkbox" type="checkbox" id="isActive" name="isActive" [(ngModel)]="user.IsActive">
            <label class="form-check-label ps-2" for="isActive">Active</label>
        </div>  
    </div>
    <div class="form">         
        <div>
            <label class="form-label" for="userFirstName">User's First Name</label>
            <input class="form-control" type="text" id="userFirstName" name="userFirstName" [(ngModel)]="user.FirstName" />
        </div>
        <div>
            <label class="form-label" for="userLastName">User's Last Name</label>
            <input class="form-control" type="text" id="userLastName" name="userLastName" [(ngModel)]="user.LastName" />
        </div>
        <div>
            <label class="form-label" for="userEmail">User's Email</label>
            <input class="form-control" type="text" id="userEmail" name="userEmail" [(ngModel)]="user.Email" />
        </div>
        <div>
            <label class="form-label me-5 mt-0">External ID (National ID)</label>
            <div class="text-end d-inline ms-5 mb-0">
                <input id="verifyExternalId" name="verifyExternalId" class="form-checkbox" type="checkbox" [(ngModel)]="user.VerifyExternalId" /><label class="form-label mt-0 mb-0 ps-2" for="verifyExternalId">Verify External ID</label>
            </div>
            <input class="form-control" type="text" id="userExternalId" name="userExternalId" [(ngModel)]="user.ExternalId" />
        </div>
        <div class="mt-2">
            <input class="form-checkbox" type="checkbox" id="dexioAdmin" name="dexioAdmin" [(ngModel)]="user.IsAdmin" />
            <label class="form-label mt-0 mb-0 ps-2" for="dexioAdmin">Is Dexio Admin?</label>
        </div>
        <div class="initial-permissions-container"> 
            <div>
                <label class="form-label" for="userProject">Initial Project Permissions</label>
                <select class="form-select" id="userProject" name="userProject" [(ngModel)]="user.Project">
                    <option selected="selected" [ngValue]="null">No project</option>
                    <option *ngFor="let project of projects" [ngValue]="project">{{project.projectName}}</option>
                </select>
            </div>
            <div *ngIf="user?.Project?.roles && user?.Project?.roles.length > 0">
                <div class="col-12">
                    <div>
                        <label class="form-label">Permissions</label>
                    </div>
                    <hr />
                    <div *ngFor="let role of user?.Project?.roles" class="form-group">
                        <input class="form-check-input role-checkbox" type="checkbox" id="{{role}}_checkbox" [value]="role" />
                        <label class="form-check-label" for="{{role}}_checkbox">{{role}}</label>
                    </div>
                </div>
            </div>  
        </div>  
    </div>
    <div class="mt-3 row">
        <div class="col">
            <button type="button" class="btn btn-secondary" (click)="close()">Cancel</button>
        </div>
        <div class="col text-end">
            <button type="button" class="btn btn-primary" (click)="save()">Save</button>
        </div>
    </div>  
</div>
